module.exports = __webpack_public_path__ + "pc/static/img/voucher.02229bfd.png";